<template>
  <p>
    <!-- 1 立减券 2折扣券 -->
    <template
      v-if="
        couponInfos.couponType * 1 === 1 &&
        couponInfos.currency &&
        couponInfos.couponDisplayDiscount
      "
    >
      <i18n path="ranking.amount_coupon" tag="span">
        <span place="currency" class="currency">{{
          couponInfos.currency
        }}</span>
        <span place="money" class="money">{{
          couponInfos.couponDisplayDiscount
        }}</span>
      </i18n>
    </template>
    <template
      v-if="
        couponInfos.couponType * 1 === 2 && couponInfos.couponDisplayDiscount
      "
    >
      <i18n path="ranking.discount_coupon" tag="span">
        <span place="number" class="number">{{
          couponInfos.couponDisplayDiscount
        }}</span>
      </i18n>
    </template>
  </p>
</template>
<script>
  export default {
    props: {
      list: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      couponInfos() {
        const { coupon = {} } = this.list || {}
        return coupon
      },
    },
  }
</script>
